import React from "react";
import { Select } from "antd";
import { getIcon } from "variables/constants";

const SelectOption = ({
  placeholder,
  options = [],
  className = "",
  value,
  onChange,
  showLabel = true,        
  showIcons = false,       
  showSelectedIconOnly = false, 
  ...rest
}) => {
  const renderOptionContent = (option) => {
    const icon = showIcons && option.code ? getIcon(option.code) : null;
    const label = showLabel ? option.label : null;

    return (
      <div className="flex items-center gap-2">
        {icon}
        {label}
      </div>
    );
  };

  const getOptionLabelProp = (option) => {
    const icon = showIcons && option.code ? getIcon(option.code) : null;
    const label = showLabel ? option.label : null;

    return showSelectedIconOnly ? icon || label : (
      <div className="flex items-center gap-2">
        {icon}
        {label}
      </div>
    );
  };

  return (
    <div className={`bg-gray-50 rounded-lg h-9 flex items-center 	dark:border dark:border-gray-200  bg-gray-50 dark:bg-white/30 ${className}`}>
      <Select
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        allowClear={false}
        //listHeight={options.length * 32}
        className="w-full text-[14px]"
        optionLabelProp="label"
        dropdownMatchSelectWidth={false}
        variant="borderless"
        {...rest}
      >
        {options.map((option) => (
          <Select.Option
            key={option.value}
            value={option.value}
            label={getOptionLabelProp(option)}
          >
            {renderOptionContent(option)}
          </Select.Option>
        ))}
      </Select>
    </div>
  );
};

export default SelectOption;
